import React from "react";
import {useNavigate} from "react-router-dom";
import {Header, StyledButton, StyledCard, Subtext,} from "./CheckYourMailbox.styled";
import {AuthContainer} from "./Auth.styled";
import Logo from "../../assets/images/taia_logo.png";
import { usePageTitle } from '../../hooks/usePageTitle';
import { PageTitleKeys } from '../../config/routeConstants';
import {useTranslation} from 'react-i18next';
import LogoWithLanguageSwitcher from '../../components/common/LogoWithLanguageSwitcher';

const ThankYouForRegistration: React.FC = () => {
    usePageTitle(PageTitleKeys.ThankYouForRegistration);
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <AuthContainer role="region" aria-labelledby="thank-you-title">
            <LogoWithLanguageSwitcher src={Logo} alt={t('auth.logo.alt')} clickable={false} />
            <StyledCard>
                <Header id="thank-you-title">{t('thankYouForRegistration.title')}</Header>
                <Subtext>{t('thankYouForRegistration.subtitle')}</Subtext>
                <StyledButton 
                    onClick={() => navigate("/login")}
                    aria-label={t('thankYouForRegistration.backButton') as string}
                >
                    {t('thankYouForRegistration.backButton')}
                </StyledButton>
            </StyledCard>
        </AuthContainer>
    );
};

export default ThankYouForRegistration;
